export default {
  TARGETS: (state) => {
    return state.targets
  }
}
